type SystemInfoBlockProps = {
  text: string;
};

const SystemInfoBlock = ({ text }: SystemInfoBlockProps) => {
  return (
    <div className="flex items-center justify-center w-full py-[10px]" data-name="system-info-block">
      <div className="px-[12px] py-[8px] bg-[#e9ebef] rounded-[8px] max-w-[80%]">
        <p className="font-['Manrope:Regular',sans-serif] font-normal leading-[1.4] text-[#717182] text-[12px] text-center">
          {text}
        </p>
      </div>
    </div>
  );
}

export default SystemInfoBlock;
